var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductionSupport3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2301.16 1360.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:url(#linear-gradient);}.cls-11,.cls-3,.cls-5{fill:#fff;}.cls-3{opacity:0.57;}.cls-4{fill:#91b3fa;}.cls-6{fill:url(#linear-gradient-2);}.cls-7{fill:#18174a;}.cls-8{fill:#2b69b3;}.cls-9{fill:#bdd0fb;}.cls-10{fill:#dce5fe;}.cls-11{opacity:0.5;}.cls-12{clip-path:url(#clip-path);}.cls-13{fill:#7d97f4;}.cls-14{fill:url(#linear-gradient-3);}.cls-15{fill:url(#linear-gradient-4);}.cls-16{fill:url(#linear-gradient-5);}.cls-17{fill:url(#linear-gradient-6);}.cls-18{fill:url(#linear-gradient-7);}.cls-19{fill:url(#linear-gradient-8);}.cls-20{fill:url(#linear-gradient-9);}.cls-21{fill:url(#linear-gradient-10);}.cls-22{fill:url(#linear-gradient-11);}.cls-23{fill:url(#linear-gradient-12);}.cls-24{fill:url(#linear-gradient-13);}.cls-25{fill:url(#linear-gradient-14);}.cls-26{fill:url(#linear-gradient-15);}.cls-27{fill:url(#linear-gradient-16);}.cls-28{fill:url(#linear-gradient-17);}.cls-29{fill:url(#linear-gradient-18);}.cls-30{fill:url(#linear-gradient-19);}.cls-31{fill:url(#linear-gradient-20);}.cls-32{fill:url(#linear-gradient-21);}.cls-33{fill:url(#linear-gradient-22);}.cls-34{fill:url(#linear-gradient-23);}.cls-35{fill:url(#linear-gradient-24);}.cls-36{fill:url(#linear-gradient-25);}.cls-37{fill:url(#linear-gradient-26);}.cls-38{fill:url(#linear-gradient-27);}.cls-39{fill:url(#linear-gradient-28);}.cls-40{fill:url(#linear-gradient-29);}.cls-41{fill:url(#linear-gradient-30);}.cls-42{fill:url(#linear-gradient-31);}.cls-43{fill:url(#linear-gradient-32);}.cls-44{fill:url(#linear-gradient-33);}.cls-45{fill:url(#linear-gradient-34);}.cls-46{fill:url(#linear-gradient-35);}.cls-47{fill:url(#linear-gradient-36);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -84.41,
    y1: 1723.55,
    x2: 2216.96,
    y2: 52.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 2025.56,
    y1: 349.06,
    x2: 1420.41,
    y2: 1152.5,
    gradientTransform: "translate(2194.21 -1206.21) rotate(81.96)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1577.72,1007.29c-7.06-7.18-22.44-34.88-35.63-106.51-12.74-69.23-19.76-159-19.76-252.84s7-183.6,19.76-252.83c13.19-71.64,28.57-99.34,35.63-106.52,7.06,7.18,22.45,34.88,35.63,106.52,12.75,69.23,113.32,159,113.32,252.83S1626.1,831.55,1613.35,900.78C1600.17,972.41,1584.78,1000.11,1577.72,1007.29Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1081.6,
    y1: 1122.78,
    x2: 1191.6,
    y2: 1067.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb3b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1676.09,
    y1: 968.27,
    x2: 1505.07,
    y2: 1283.31,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 931.35,
    y1: 897.17,
    x2: 831.14,
    y2: 999.42,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 844.02,
    y1: 1064.76,
    x2: 1139.51,
    y2: 895.26,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 842.23,
    y1: 1061.64,
    x2: 1137.72,
    y2: 892.14,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 849.23,
    y1: 1073.84,
    x2: 1144.72,
    y2: 904.35,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 951.19,
    y1: 824.05,
    x2: 417.44,
    y2: 1528.05,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 854.58,
    y1: 799.69,
    x2: 805.08,
    y2: 894.18,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 814.85,
    y1: 969.7,
    x2: 1027.84,
    y2: 1112.2,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 738.87,
    y1: 1019.57,
    x2: 810.77,
    y2: 1019.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 756.11,
    y1: 940.44,
    x2: 879.17,
    y2: 940.44,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 816.19,
    y1: 723.19,
    x2: 891.18,
    y2: 846.19,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 780.98,
    y1: 744.66,
    x2: 855.98,
    y2: 867.66,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1080.59,
    y1: 1120.77,
    x2: 1190.59,
    y2: 1065.77,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 1481.11,
    y1: 830.1,
    x2: 1505.11,
    y2: 942.1,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1542.29,
    y1: 1012.89,
    x2: 1673.3,
    y2: 1082.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4042e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1760.82,
    y1: 991.56,
    x2: 1661.12,
    y2: 1183.29,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 1407.19,
    y1: 748.32,
    x2: 1483.19,
    y2: 797.32,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 3029.44,
    y1: 3955.99,
    x2: 3117.88,
    y2: 3865.25,
    gradientTransform: "matrix(-0.69, -0.73, -0.73, 0.69, 6453.86, 435.95)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 291.8,
    y1: 1168.66,
    x2: 358.06,
    y2: 1168.66,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 240.45,
    y1: 1169.32,
    x2: 408.77,
    y2: 1169.32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 512.93,
    y1: 1041.94,
    x2: 550.27,
    y2: 1041.94,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 486.55,
    y1: 1042.28,
    x2: 576.31,
    y2: 1042.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 340.36,
    y1: 487.2,
    x2: 358.94,
    y2: 487.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 371.42,
    y1: 512.2,
    x2: 390,
    y2: 512.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 402.47,
    y1: 450.43,
    x2: 421.06,
    y2: 450.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 433.53,
    y1: 533.62,
    x2: 452.12,
    y2: 533.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 464.59,
    y1: 465.07,
    x2: 483.18,
    y2: 465.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 495.65,
    y1: 481.49,
    x2: 514.23,
    y2: 481.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 526.71,
    y1: 499.34,
    x2: 545.29,
    y2: 499.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 557.76,
    y1: 428.29,
    x2: 576.35,
    y2: 428.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 588.82,
    y1: 442.22,
    x2: 607.41,
    y2: 442.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 619.88,
    y1: 463.28,
    x2: 638.47,
    y2: 463.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 650.94,
    y1: 536.06,
    x2: 669.53,
    y2: 536.06,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2261.11,642.22C2200,561,2070.61,517.5,2067.25,395.8c-2.19-79.08,35.5-121.94-24.81-189.45C1896.66,43.17,1672,24.05,1480.17,92.22S1135.16,297,922,288.73c-116.11-4.49-224-57-338.91-66.81-35.41-3-68.49-.44-99.42,7.11-116,28.29-218.37,134.54-256.93,252.58-31.26,95.68,8.68,190.14-40.4,283.83C134,865.31,31,934.68,5,1050c-31.15,138.39,87.86,258.73,215.71,262.49,81.38,2.4,232.22-10,301.36-57.8,84.17-58.23,166.91-62.06,265-59.83,186.76,4.24,373.51,44.27,557.86,72.77,158,24.42,313.66,60.58,473.75,65.17,117.57,3.37,217.35,4.89,281-116.74C2175.75,1070.68,2389.21,812.55,2261.11,642.22Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 1791.42,
    cy: 659.92,
    r: 314.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 1791.42,
    cy: 659.92,
    r: 268.76,
    transform: "translate(58.06 1460.01) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1791.42,941.17c-155.08,0-281.24-126.17-281.24-281.25s126.16-281.24,281.24-281.24,281.24,126.16,281.24,281.24S1946.5,941.17,1791.42,941.17Zm0-537.53c-141.32,0-256.28,115-256.28,256.28s115,256.29,256.28,256.29,256.28-115,256.28-256.29S1932.74,403.64,1791.42,403.64Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 1791.42,
    cy: 659.92,
    r: 163.85,
    transform: "translate(58.06 1460.01) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1791.42,836.25c-97.23,0-176.33-79.1-176.33-176.33s79.1-176.33,176.33-176.33,176.33,79.1,176.33,176.33S1888.65,836.25,1791.42,836.25Zm0-327.7c-83.47,0-151.37,67.9-151.37,151.37s67.9,151.37,151.37,151.37,151.37-67.9,151.37-151.37S1874.89,508.55,1791.42,508.55Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 1791.42,
    cy: 659.92,
    r: 63.48,
    transform: "translate(887.35 2341.39) rotate(-81.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1791.42,735.88a76,76,0,1,1,76-76A76,76,0,0,1,1791.42,735.88Zm0-127a51,51,0,1,0,51,51A51.06,51.06,0,0,0,1791.42,608.92Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 2010.73,
    y: 214.85,
    width: 12,
    height: 454.51,
    transform: "translate(3130.19 2180.75) rotate(-135)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1857.81,578.08c4.87-4.87,27.82,18.08,23,22.95L1795.62,668a3.37,3.37,0,0,1-4.74-4.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2181.49,285.84l43.24,4.3-59.36,59.35a91.76,91.76,0,0,1-74,26.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2173,277.35l-4.3-43.24-59.35,59.36a91.76,91.76,0,0,0-26.43,74h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M668.14,823s124.6-413.62,344.31-630.16c14.77-14.55,39.79-7.1,44,13.19C1085,341.77,1130.84,750.93,668.14,823Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M711.56,798.5a1.14,1.14,0,0,0,1.38,1.82c44.27-29,217.41-174,296.43-478.95a.79.79,0,0,0-1.51-.49C983,391.17,883.05,649.89,711.56,798.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1580.35,1345.48S1705,931.86,1924.67,715.32c14.77-14.56,39.78-7.1,44,13.19C1997.25,864.21,2043.06,1273.36,1580.35,1345.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1623.78,1320.93a1.14,1.14,0,0,0,1.37,1.82c44.27-29,217.41-174,296.44-478.95a.8.8,0,0,0-1.52-.49C1895.2,913.61,1795.26,1172.33,1623.78,1320.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M749.13,1102.91S581.73,700.1,338.89,505c-16.32-13.12-40.69-3.08-42.9,17.75C281.18,662,276.92,1077.69,749.13,1102.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M703,1082.69a1.15,1.15,0,0,1-1.19,2c-47.44-24.58-236.18-152.59-346.7-450.91a.81.81,0,0,1,1.48-.64C388.74,701.18,515.55,950.9,703,1082.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M846.39,919.82S789.33,465.26,597.92,199.93c-12.87-17.83-40.34-14.47-48.4,6C495.66,342.77,375.33,762.5,846.39,919.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M805.33,886.46a1.21,1.21,0,0,1-1.76,1.66C762.41,850,607,667.71,578.39,334.83a.85.85,0,0,1,1.68-.25C593.62,412.49,652.32,700.72,805.33,886.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M603,796.38S731,1133.78,771.39,1204c46.91,81.47,183.94,29.56,177.12-38.63s-166.91-350-166.91-350Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "785.93 542.6 1581.08 266.91 1572.73 1012.97 764.2 832.57 785.93 542.6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1571.79,
    cy: 650.11,
    rx: 78.12,
    ry: 383.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1577.72,1007.29c-7.06-7.18-22.44-34.88-35.63-106.51-12.74-69.23-19.76-159-19.76-252.84s7-183.6,19.76-252.83c13.19-71.64,28.57-99.34,35.63-106.52,7.06,7.18,22.45,34.88,35.63,106.52,12.75,69.23,19.77,159,19.77,252.83s-7,183.61-19.77,252.84C1600.17,972.41,1584.78,1000.11,1577.72,1007.29Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1677.85,645.09c0,65.14-35.09,117.95-104.55,117.95s-125.76-52.81-125.76-117.95,56.3-118,125.76-118S1677.85,579.94,1677.85,645.09Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M647.65,534.56c37.41-4.34,91-5.9,149,7.38-19.11,99.81-16.22,203.84,5.87,311.56H639a53,53,0,0,1-52.39-44.7c-8.15-51.64-18.11-138.42-7.49-208.13A78.45,78.45,0,0,1,647.65,534.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M871.59,1207.75a85.25,85.25,0,0,1-18.15-2,83.92,83.92,0,0,1-59.2-48L692.42,931.62a5.17,5.17,0,0,1,9.44-4.24l101.82,226.2a73.63,73.63,0,0,0,52,42.08,72.16,72.16,0,0,0,63.45-16.21c.95-.84,1.9-1.69,2.86-2.57a5.18,5.18,0,1,1,7,7.64c-1,.93-2,1.84-3,2.72A82.07,82.07,0,0,1,871.59,1207.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M682.09,901.23a5.21,5.21,0,0,1-4.73-3.05L666,872.94a5.18,5.18,0,1,1,9.44-4.25l11.36,25.24a5.19,5.19,0,0,1-4.72,7.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1659.23,643.59a5.18,5.18,0,0,1-5.16-4.81c-2.22-31.32-13-54.65-32.09-69.32-33-25.42-80.61-16.72-81.09-16.62a5.18,5.18,0,0,1-2-10.17c2.13-.41,52.5-9.71,89.3,18.54,21.56,16.55,33.73,42.4,36.17,76.83a5.18,5.18,0,0,1-4.8,5.53A2.3,2.3,0,0,1,1659.23,643.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M753.16,607.07H620.8a12.07,12.07,0,0,1-10.13-18.63,3.4,3.4,0,1,1,5.71,3.7,5.27,5.27,0,0,0,4.42,8.12H753.16a5.27,5.27,0,0,0,5.27-5.26v-9.42a5.27,5.27,0,0,0-5.27-5.27H619.82a3.4,3.4,0,0,1,0-6.8H753.16a12.09,12.09,0,0,1,12.08,12.07V595A12.09,12.09,0,0,1,753.16,607.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M741.36,665.69H609a12.07,12.07,0,0,1-10.14-18.63,3.41,3.41,0,1,1,5.72,3.7,5.26,5.26,0,0,0,4.42,8.12H741.36a5.27,5.27,0,0,0,5.27-5.26V644.2a5.28,5.28,0,0,0-5.27-5.27H608a3.4,3.4,0,1,1,0-6.8H741.36a12.08,12.08,0,0,1,12.07,12.07v9.42A12.08,12.08,0,0,1,741.36,665.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M753.16,734.34H620.8a12.07,12.07,0,0,1-10.13-18.63,3.4,3.4,0,1,1,5.71,3.7,5.26,5.26,0,0,0,4.42,8.12H753.16a5.27,5.27,0,0,0,5.27-5.26v-9.42a5.27,5.27,0,0,0-5.27-5.26H619.82a3.41,3.41,0,0,1,0-6.81H753.16a12.09,12.09,0,0,1,12.08,12.07v9.42A12.09,12.09,0,0,1,753.16,734.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M765.56,810.54H633.2a12.06,12.06,0,0,1-10.14-18.62,3.4,3.4,0,0,1,5.72,3.69,5.26,5.26,0,0,0,4.42,8.13H765.56a5.27,5.27,0,0,0,5.26-5.27v-9.41a5.27,5.27,0,0,0-5.26-5.27H632.21a3.4,3.4,0,0,1,0-6.8H765.56a12.08,12.08,0,0,1,12.07,12.07v9.41A12.08,12.08,0,0,1,765.56,810.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M895.05,535.13a3.31,3.31,0,0,1-1-6.46l607.57-193.34a3.31,3.31,0,1,1,2,6.3L896.05,535A3.46,3.46,0,0,1,895.05,535.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M812.89,568.72a3.31,3.31,0,0,1-1.25-6.37l31.26-12.78a3.31,3.31,0,1,1,2.51,6.12l-31.27,12.78A3.28,3.28,0,0,1,812.89,568.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1079.29,695.69c-62.84,58.7-332.69,335.1-187.49,630a8.56,8.56,0,0,0,14.53,1.35c40.63-54.51,215.29-309.23,187.3-625.81A8.54,8.54,0,0,0,1079.29,695.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1045.13,788.78a1.16,1.16,0,0,0-2-1.22c-38,56.33-144.39,238-140.85,503.87C902.32,1291.43,911.67,1028.38,1045.13,788.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1189.23,950.4c-57,22.47-308.35,135.12-289.26,368.67a6.1,6.1,0,0,0,9.28,4.7c41.21-25.51,223.72-148.7,288-366A6.09,6.09,0,0,0,1189.23,950.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1142.2,1003.19a.82.82,0,0,0-1-1.32c-40,27.39-158.05,120-225.32,297.25C915.9,1299.12,991,1127.14,1142.2,1003.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M161.63,885.3c61.23,3,335.4,29.07,392.23,256.4a6.09,6.09,0,0,1-7.28,7.43c-47.22-10.94-259.6-69.08-390.21-254.22A6.09,6.09,0,0,1,161.63,885.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M223.1,920.22a.83.83,0,0,1,.51-1.57c46.65,13.13,188.2,63,308.76,209.27C532.37,1127.92,406.1,989.11,223.1,920.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2130.59,1089.62c-61.27-2.28-336.66.16-412.8,221.78a6.09,6.09,0,0,0,6.62,8c48-6.84,264.57-46.53,410.6-219.78A6.09,6.09,0,0,0,2130.59,1089.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2066.34,1119.13a.83.83,0,0,0-.36-1.61c-47.61,9.07-192.91,46.59-325.59,182C1740.39,1299.51,1878.11,1172.05,2066.34,1119.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M435.23,800.64l-2.77-5.25a1.32,1.32,0,0,1,.55-1.8,1.34,1.34,0,0,1,1.8.55h0l0,.05,2.71,5.15,0,0a1.33,1.33,0,0,1-2.35,1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M427,782.65,425.13,777a1.34,1.34,0,0,1,2.55-.83h0l0,.08,1.79,5.51,0,.08a1.34,1.34,0,0,1-2.54.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M422.21,763.39c-.27-2-.46-4-.59-5.95a1.36,1.36,0,0,1,2.71-.17h0c.12,1.92.3,3.84.56,5.75a1.37,1.37,0,0,1-1.17,1.52A1.35,1.35,0,0,1,422.21,763.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M422,743.5c.23-2,.55-4,.94-5.91a1.37,1.37,0,0,1,2.68.54h0c-.38,1.88-.68,3.79-.91,5.7a1.37,1.37,0,1,1-2.71-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M426.92,724.22c.73-1.85,1.54-3.68,2.41-5.47a1.38,1.38,0,1,1,2.48,1.21h0q-1.26,2.6-2.34,5.28a1.37,1.37,0,1,1-2.55-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M436.4,706.76,440,702a1.39,1.39,0,1,1,2.23,1.66h0l-.05.07-3.46,4.64-.06.07a1.39,1.39,0,0,1-2.22-1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M449.28,691.68l4.35-4a1.4,1.4,0,0,1,1.91,2h0l-.05.05-4.26,3.95-.05.05a1.4,1.4,0,0,1-1.9-2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M464.43,679l4.87-3.39a1.41,1.41,0,1,1,1.62,2.32h0l-.05,0-4.78,3.32,0,0a1.41,1.41,0,0,1-1.62-2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M481.09,668.35l5.21-2.81a1.43,1.43,0,1,1,1.36,2.51h0l0,0-5.14,2.77,0,0a1.43,1.43,0,1,1-1.35-2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M498.75,659.56l5.44-2.31a1.44,1.44,0,1,1,1.13,2.65h0l-5.38,2.28,0,0a1.44,1.44,0,0,1-1.12-2.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M517.1,652.36l5.6-1.88a1.45,1.45,0,1,1,.92,2.76h0l-5.54,1.85h0a1.45,1.45,0,1,1-.92-2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M535.92,646.57l5.71-1.49a1.46,1.46,0,1,1,.74,2.83h0l-5.66,1.47h0a1.46,1.46,0,1,1-.73-2.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M555.07,642l5.8-1.13a1.47,1.47,0,0,1,1.73,1.16,1.49,1.49,0,0,1-1.17,1.74h0l-5.75,1.12h0a1.47,1.47,0,0,1-.57-2.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M574.46,638.65l5.85-.8a1.49,1.49,0,0,1,.4,2.95h0l-5.8.79h0a1.48,1.48,0,0,1-.4-2.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M594,636.35l5.88-.49a1.5,1.5,0,1,1,.25,3h0l-5.83.47h0a1.49,1.49,0,0,1-.24-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M613.63,635.08l5.9-.19a1.51,1.51,0,1,1,.09,3h0l-5.86.18h0a1.51,1.51,0,0,1-.09-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M633.3,634.79l5.9.1a1.53,1.53,0,1,1-.06,3.05h0l-5.86-.11h0a1.52,1.52,0,1,1,.06-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M653,635.47l5.89.38a1.54,1.54,0,1,1-.2,3.07h0l-5.85-.39h0a1.53,1.53,0,1,1,.2-3.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M672.55,637.07l5.86.6a1.55,1.55,0,0,1-.32,3.09h0l-5.83-.61h0a1.54,1.54,0,1,1,.32-3.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M692.06,639.27l5.84.77a1.56,1.56,0,1,1-.4,3.09h0l-5.82-.77h0a1.56,1.56,0,0,1,.4-3.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M711.51,642l5.82.9a1.57,1.57,0,1,1-.48,3.1h0l-5.79-.91h0a1.56,1.56,0,0,1,.49-3.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M730.88,645.18l5.8,1.05a1.58,1.58,0,0,1-.56,3.11h0l-5.77-1.06h0a1.58,1.58,0,0,1,.56-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M750.17,648.84l5.77,1.18a1.59,1.59,0,0,1-.64,3.12h0L749.54,652h0a1.59,1.59,0,0,1,.64-3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M769.37,652.94l5.74,1.31a1.6,1.6,0,1,1-.71,3.12h0l-5.72-1.32h0a1.6,1.6,0,0,1,.71-3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M788.48,657.46l5.71,1.44a1.61,1.61,0,1,1-.79,3.12h0l-5.69-1.43h0a1.59,1.59,0,0,1-1.16-1.94A1.6,1.6,0,0,1,788.48,657.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M807.48,662.38l5.68,1.55a1.62,1.62,0,1,1-.85,3.12h0l-5.66-1.55a1.62,1.62,0,1,1,.84-3.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M826.38,667.67l5.65,1.66a1.63,1.63,0,0,1-.92,3.13h0l-5.63-1.66a1.63,1.63,0,1,1,.91-3.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M845.18,673.32l5.62,1.75a1.64,1.64,0,0,1-1,3.13h0l-5.6-1.76a1.63,1.63,0,1,1,1-3.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M863.87,679.29l5.59,1.85a1.65,1.65,0,1,1-1,3.13h0l-5.57-1.85a1.65,1.65,0,1,1,1-3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M882.46,685.57l5.56,1.94a1.66,1.66,0,0,1-1.09,3.13h0l-5.54-1.94a1.65,1.65,0,0,1-1-2.1A1.66,1.66,0,0,1,882.46,685.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M901,692.13l5.52,2a1.67,1.67,0,0,1-1.14,3.14h0l-5.51-2a1.67,1.67,0,1,1,1.14-3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M919.35,698.94l5.5,2.1a1.67,1.67,0,1,1-1.19,3.13h0l-5.49-2.09a1.68,1.68,0,0,1,1.19-3.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M937.66,706l5.47,2.16a1.69,1.69,0,0,1-1.24,3.14h0l-5.47-2.16a1.69,1.69,0,1,1,1.24-3.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M955.88,713.27l5.45,2.22a1.7,1.7,0,0,1-1.29,3.15h0l-5.44-2.22a1.7,1.7,0,0,1-.94-2.21A1.72,1.72,0,0,1,955.88,713.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M974,720.73l5.42,2.27a1.71,1.71,0,1,1-1.32,3.16h0l-5.42-2.27a1.71,1.71,0,1,1,1.32-3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M992.08,728.37l5.41,2.32a1.72,1.72,0,1,1-1.36,3.15h0l-5.4-2.32a1.71,1.71,0,1,1,1.35-3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1010.08,736.15l5.39,2.36a1.73,1.73,0,0,1-1.39,3.17h0l-5.38-2.36a1.72,1.72,0,1,1,1.38-3.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1028,744.06l5.37,2.4a1.73,1.73,0,0,1-1.41,3.17h0l-5.36-2.4a1.73,1.73,0,1,1,1.41-3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1045.91,752.08l5.36,2.42a1.75,1.75,0,0,1-1.44,3.19h0l-5.35-2.43a1.74,1.74,0,1,1,1.43-3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1063.76,760.19l5.35,2.44a1.76,1.76,0,1,1-1.46,3.2h0l-5.35-2.45a1.75,1.75,0,0,1,1.46-3.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1081.58,768.36l5.34,2.46a1.77,1.77,0,1,1-1.48,3.21h0l-5.34-2.46a1.77,1.77,0,0,1,1.48-3.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1099.38,776.57l5.33,2.47a1.78,1.78,0,0,1-1.49,3.23h0l-5.34-2.47a1.78,1.78,0,0,1,1.5-3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1117.16,784.79l5.34,2.47a1.79,1.79,0,0,1-1.5,3.25h0l-5.34-2.47a1.79,1.79,0,0,1,1.5-3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1135,793l5.34,2.46a1.8,1.8,0,0,1-1.5,3.27h0l-5.34-2.46A1.8,1.8,0,0,1,1135,793Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1152.75,801.18l5.35,2.44a1.81,1.81,0,1,1-1.5,3.29h0l-5.35-2.45a1.8,1.8,0,1,1,1.5-3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1170.58,809.3l5.35,2.42a1.82,1.82,0,1,1-1.49,3.32h0l-5.36-2.43a1.82,1.82,0,0,1,1.5-3.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1188.44,817.34l5.37,2.39a1.83,1.83,0,0,1-1.49,3.35h0l-5.37-2.41a1.82,1.82,0,1,1,1.49-3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1206.34,825.28l5.38,2.36a1.84,1.84,0,1,1-1.47,3.37h0l-5.39-2.37a1.84,1.84,0,1,1,1.48-3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1224.3,833.1l5.39,2.32a1.85,1.85,0,1,1-1.45,3.4h0l-5.41-2.33a1.85,1.85,0,0,1,1.47-3.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1242.31,840.78l5.41,2.27a1.86,1.86,0,1,1-1.42,3.43h0l-5.42-2.28a1.86,1.86,0,0,1,1.44-3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1260.39,848.29l5.44,2.21a1.87,1.87,0,0,1-1.4,3.47h0l-5.45-2.23a1.87,1.87,0,1,1,1.42-3.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1278.54,855.61l5.46,2.15a1.88,1.88,0,1,1-1.36,3.5h0l-5.47-2.17a1.87,1.87,0,1,1,1.38-3.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1296.78,862.72l5.49,2.09a1.89,1.89,0,0,1-1.33,3.53h0l-5.5-2.1a1.89,1.89,0,1,1,1.35-3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1315.1,869.59l5.52,2a1.9,1.9,0,0,1-1.29,3.57h0l-5.53-2a1.9,1.9,0,1,1,1.31-3.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1333.52,876.21l5.54,1.93a1.91,1.91,0,0,1-1.24,3.62h0l-5.56-1.94a1.91,1.91,0,1,1,1.27-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1352,882.55l5.57,1.84a1.92,1.92,0,1,1-1.19,3.65h0l-5.59-1.86a1.91,1.91,0,1,1,1.22-3.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1370.64,888.59l5.6,1.75h0a1.93,1.93,0,0,1-1.15,3.68h0l-5.62-1.76a1.93,1.93,0,1,1,1.15-3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1389.34,894.3l5.64,1.64h0a1.94,1.94,0,0,1-1.09,3.72h0l-5.65-1.66a1.94,1.94,0,1,1,1.09-3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1408.15,899.66l5.67,1.54h0a1.95,1.95,0,0,1-1,3.76h0l-5.68-1.55a1.94,1.94,0,0,1,1-3.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1427.06,904.65l5.69,1.42h0a2,2,0,0,1-1,3.81h0l-5.72-1.44a2,2,0,0,1,1-3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1446.07,909.25l5.72,1.3h0a2,2,0,1,1-.87,3.84h0l-5.75-1.31a2,2,0,1,1,.88-3.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1465.17,913.44l5.75,1.17h0a2,2,0,0,1-.79,3.88h0l-5.78-1.19a2,2,0,1,1,.8-3.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1484.36,917.19l5.77,1h0a2,2,0,0,1-.7,3.92h0l-5.8-1a2,2,0,0,1,.7-3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1503.62,920.49l5.8.89h0a2,2,0,1,1-.6,4h0l-5.82-.9a2,2,0,1,1,.61-3.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1523,923.26l5.82.72h0a2,2,0,0,1-.5,4h0l-5.85-.73a2,2,0,1,1,.5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1542.38,925.48l5.83.56h0a2,2,0,1,1-.39,4h0l-5.87-.57a2,2,0,1,1,.39-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1561.84,927.15l5.85.39h0a2,2,0,0,1-.27,4.05h0l-5.88-.4a2,2,0,0,1,.28-4.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1581.35,928.26l5.86.23h0a2,2,0,0,1-.15,4.07h0l-5.89-.23a2,2,0,0,1,.16-4.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1600.88,928.82l5.86,0h0a2.05,2.05,0,1,1,0,4.1h0l-5.9-.06a2,2,0,0,1,0-4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1620.42,928.81l5.86-.12h0a2.06,2.06,0,1,1,.08,4.12h0l-5.89.11a2.06,2.06,0,1,1-.08-4.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1639.94,928.22l5.86-.29h0a2.07,2.07,0,0,1,.2,4.14h0l-5.89.28a2.06,2.06,0,1,1-.2-4.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1659.44,927.05l5.84-.47h0a2.08,2.08,0,0,1,.34,4.14h0l-5.88.47a2.08,2.08,0,0,1-.33-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1678.89,925.27l5.83-.65h0a2.09,2.09,0,0,1,.46,4.15h0l-5.86.65a2.08,2.08,0,1,1-.46-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1698.27,922.87l5.8-.85h0a2.1,2.1,0,0,1,.61,4.16h0l-5.84.84a2.1,2.1,0,1,1-.6-4.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1717.56,919.82l5.76-1h0a2.11,2.11,0,0,1,.75,4.15h0l-5.81,1.05a2.1,2.1,0,1,1-.75-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1736.73,916.1l5.72-1.25h0a2.11,2.11,0,0,1,.91,4.13h0l-5.76,1.25a2.11,2.11,0,1,1-.9-4.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1755.74,911.68l5.67-1.46h0a2.13,2.13,0,0,1,1.07,4.12h0l-5.71,1.47a2.12,2.12,0,1,1-1.06-4.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1774.56,906.53l5.6-1.69h0a2.14,2.14,0,0,1,1.23,4.1h0l-5.65,1.7a2.14,2.14,0,1,1-1.23-4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1793.15,900.62l5.53-1.93h0a2.15,2.15,0,1,1,1.42,4h0l-5.58,1.94a2.14,2.14,0,1,1-1.41-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1811.46,893.91l5.43-2.17h0a2.16,2.16,0,0,1,1.61,4h0l-5.49,2.19a2.16,2.16,0,1,1-1.59-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1829.44,886.37l5.32-2.43h0a2.17,2.17,0,0,1,1.8,3.94h0l-5.38,2.45a2.17,2.17,0,0,1-2.87-1.08,2.15,2.15,0,0,1,1.07-2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1847,878l5.18-2.69,0,0a2.18,2.18,0,0,1,2,3.87h0l-5.25,2.72a2.17,2.17,0,0,1-2-3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1864.13,868.65l5-3,0,0a2.19,2.19,0,0,1,2.23,3.77h0l-5.1,3a2.18,2.18,0,0,1-2.22-3.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1880.69,858.41l4.84-3.26,0,0a2.2,2.2,0,0,1,2.45,3.65h0l-4.92,3.3a2.2,2.2,0,0,1-2.44-3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1896.6,847.21l4.64-3.55,0,0a2.21,2.21,0,0,1,2.69,3.51h0l-4.7,3.59a2.2,2.2,0,0,1-2.68-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1911.78,835l4.39-3.83,0,0a2.22,2.22,0,0,1,2.92,3.34h0l-4.47,3.89a2.21,2.21,0,1,1-2.91-3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1926.12,821.91l4.13-4.12,0,0a2.23,2.23,0,1,1,3.15,3.16h0l-4.2,4.18a2.22,2.22,0,1,1-3.14-3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1939.54,807.84l3.84-4.39,0,0a2.24,2.24,0,0,1,3.37,3h0l-3.9,4.46a2.24,2.24,0,1,1-3.37-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1952,792.9l3.53-4.64,0,0a2.25,2.25,0,0,1,3.58,2.72h0l-3.59,4.72a2.25,2.25,0,0,1-3.58-2.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1963.39,777.15l3.21-4.87,0,0a2.26,2.26,0,1,1,3.77,2.49h0l-3.27,4.94a2.25,2.25,0,1,1-3.76-2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1973.72,760.68l2.88-5.07,0,0a2.27,2.27,0,0,1,4,2.24h0l-2.94,5.15a2.26,2.26,0,0,1-3.93-2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1983,743.56l2.55-5.25,0,0a2.28,2.28,0,0,1,4.1,2h0l-2.6,5.32a2.27,2.27,0,0,1-4.09-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1991.07,725.89l2.22-5.4,0,0a2.29,2.29,0,1,1,4.23,1.74h0l-2.26,5.48a2.28,2.28,0,1,1-4.22-1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1998.09,707.74l1.89-5.52v0a2.3,2.3,0,1,1,4.35,1.49h0l-1.92,5.6a2.29,2.29,0,0,1-4.34-1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2004,689.2l1.56-5.62v0a2.31,2.31,0,1,1,4.45,1.23h0l-1.59,5.71a2.3,2.3,0,1,1-4.44-1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2008.83,670.35l1.24-5.71v0a2.32,2.32,0,0,1,4.53,1h0l-1.26,5.78a2.32,2.32,0,1,1-4.53-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2012.59,651.25l.92-5.77v0a2.33,2.33,0,1,1,4.6.74h0l-.94,5.84a2.32,2.32,0,1,1-4.59-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2015.31,632l.61-5.81v0a2.34,2.34,0,0,1,4.65.49h0l-.63,5.89a2.34,2.34,0,0,1-4.65-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2017,612.57l.31-5.84v0a2.35,2.35,0,1,1,4.69.25h0l-.32,5.91a2.34,2.34,0,0,1-4.68-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2017.69,593.1l0-5.84v0a2.36,2.36,0,0,1,4.72,0h0l0,5.91a2.36,2.36,0,1,1-4.71,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2017.42,573.62l-.26-5.84v0a2.37,2.37,0,1,1,4.73-.21h0l.26,5.91a2.36,2.36,0,0,1-4.72.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2016.22,554.18l-.54-5.82v0a2.38,2.38,0,1,1,4.73-.44h0l.55,5.89a2.38,2.38,0,0,1-4.74.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2014.1,534.81l-.82-5.79v0a2.39,2.39,0,1,1,4.73-.66h0l.82,5.85a2.39,2.39,0,1,1-4.73.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2011.07,515.57l-1.09-5.75v0a2.4,2.4,0,1,1,4.71-.89h0l1.09,5.81a2.4,2.4,0,0,1-4.71.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2007.15,496.48l-1.34-5.69v0a2.41,2.41,0,1,1,4.69-1.11h0l1.35,5.76a2.4,2.4,0,1,1-4.68,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2002.37,477.59l-1.6-5.63v0a2.42,2.42,0,0,1,4.65-1.32h0l1.61,5.69a2.42,2.42,0,0,1-4.65,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1996.75,458.93l-1.85-5.55v0a2.43,2.43,0,0,1,4.61-1.53h0l1.86,5.61a2.42,2.42,0,1,1-4.6,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1990.31,440.53l-2.08-5.46v0a2.44,2.44,0,1,1,4.55-1.74h0l2.11,5.53a2.44,2.44,0,0,1-4.56,1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1983.09,422.43l-2.32-5.37v0a2.45,2.45,0,0,1,4.49-1.94h0l2.34,5.43a2.45,2.45,0,1,1-4.49,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1975.09,404.65l-2.54-5.26v0a2.46,2.46,0,0,1,4.43-2.14h0l2.56,5.33a2.45,2.45,0,1,1-4.42,2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1966.36,387.22l-2.75-5.15,0,0a2.47,2.47,0,0,1,4.35-2.33h0l2.78,5.22a2.47,2.47,0,0,1-4.35,2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1956.92,370.17l-3-5v0a2.48,2.48,0,1,1,4.27-2.51h0l3,5.09a2.48,2.48,0,0,1-4.27,2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1946.79,353.51l-3.17-4.92v0a2.49,2.49,0,0,1,4.18-2.7h0l3.2,5a2.49,2.49,0,1,1-4.18,2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1936,337.27l-3.36-4.79v0a2.5,2.5,0,0,1,4.09-2.87h0l3.39,4.84a2.5,2.5,0,0,1-4.09,2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1924.58,321.47l-3.54-4.65,0,0a2.51,2.51,0,0,1,4-3h0l3.58,4.7a2.51,2.51,0,0,1-4,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1912.56,306.13l-3.73-4.52,0,0a2.52,2.52,0,0,1,3.89-3.2h0l3.76,4.56a2.52,2.52,0,0,1-3.89,3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1899.94,291.25l-3.89-4.36,0,0a2.53,2.53,0,0,1,3.78-3.37h0l3.93,4.42a2.53,2.53,0,0,1-3.78,3.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1886.78,276.87l-4.06-4.22,0,0a2.54,2.54,0,0,1,3.66-3.51h0l4.09,4.26a2.54,2.54,0,0,1-3.66,3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1873.08,263l-4.21-4.06,0,0a2.55,2.55,0,1,1,3.54-3.67h0l4.24,4.11a2.54,2.54,0,0,1-3.53,3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1858.87,249.63l-4.35-3.91,0,0a2.56,2.56,0,1,1,3.42-3.81h0l4.39,3.95a2.56,2.56,0,0,1-3.42,3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1844.2,236.78l-4.5-3.75h0a2.57,2.57,0,0,1,3.3-4h0l4.53,3.8a2.57,2.57,0,1,1-3.3,3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1829.08,224.46l-4.62-3.6h0a2.58,2.58,0,0,1,3.17-4.07h0l4.66,3.63a2.58,2.58,0,0,1-3.17,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1813.55,212.65l-4.74-3.44,0,0a2.59,2.59,0,1,1,3-4.18h0l4.77,3.47a2.58,2.58,0,1,1-3,4.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1797.64,201.36l-4.85-3.29h0a2.6,2.6,0,1,1,2.92-4.3h0l4.89,3.32a2.59,2.59,0,0,1-2.92,4.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1781.37,190.58l-4.95-3.13h0a2.61,2.61,0,0,1,2.8-4.41h0l5,3.16a2.61,2.61,0,0,1-2.79,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1764.77,180.32l-5-3h0a2.62,2.62,0,1,1,2.67-4.51h0l5.08,3a2.62,2.62,0,0,1-2.67,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1747.87,170.57l-5.13-2.83h0a2.63,2.63,0,0,1,2.54-4.61h0l5.16,2.86a2.62,2.62,0,0,1-2.53,4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1730.68,161.32l-5.21-2.67h0a2.64,2.64,0,1,1,2.41-4.7h0l5.25,2.7a2.64,2.64,0,0,1-2.42,4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1713.22,152.59l-5.28-2.52h0a2.65,2.65,0,1,1,2.29-4.79h0l5.32,2.54a2.65,2.65,0,1,1-2.28,4.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1695.52,144.36l-5.36-2.37h0a2.66,2.66,0,0,1,2.15-4.86h0l5.39,2.39a2.66,2.66,0,0,1-2.15,4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1677.59,136.64l-5.42-2.22h0a2.67,2.67,0,0,1,2-4.94h0l5.46,2.24a2.66,2.66,0,1,1-2,4.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1659.45,129.42l-5.48-2.07h0a2.68,2.68,0,0,1,1.89-5h0l5.51,2.09a2.68,2.68,0,0,1-1.89,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1641.12,122.71l-5.53-1.92h0a2.69,2.69,0,0,1,1.75-5.09h0l5.57,1.93a2.68,2.68,0,1,1-1.76,5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1622.61,116.5l-5.58-1.76h0a2.69,2.69,0,0,1,1.62-5.14h0l5.63,1.78a2.7,2.7,0,1,1-1.63,5.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1603.94,110.8l-5.63-1.61h0a2.71,2.71,0,0,1,1.49-5.21h0l5.67,1.63a2.7,2.7,0,1,1-1.49,5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1585.12,105.61l-5.67-1.46h0a2.72,2.72,0,0,1,1.35-5.27h0l5.71,1.48a2.72,2.72,0,1,1-1.36,5.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1566.17,100.93l-5.71-1.31h0a2.73,2.73,0,0,1,1.21-5.32h0l5.75,1.32a2.72,2.72,0,1,1-1.22,5.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1547.1,96.76l-5.74-1.15h0a2.74,2.74,0,0,1,1.08-5.37h0l5.79,1.17a2.73,2.73,0,1,1-1.08,5.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1527.92,93.1l-5.77-1h0a2.75,2.75,0,0,1,.93-5.42h0l5.81,1a2.75,2.75,0,0,1-.94,5.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1508.65,90l-5.79-.84h0a2.76,2.76,0,1,1,.8-5.46h0l5.84.85a2.76,2.76,0,1,1-.8,5.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1489.31,87.34l-5.28-.62h0a2.77,2.77,0,1,1,.64-5.5h0l5.32.63a2.77,2.77,0,1,1-.66,5.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "1455.64 46.18 1458.55 82.73 1432.54 68.99 1455.64 46.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1289.6,38.27,1395.2,117a9.29,9.29,0,0,0,13.19-2.18l75.06-109a3.72,3.72,0,0,0-3.8-5.76Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "1455.63 46.19 1289.6 38.27 1443.57 63.81 1444.81 73.92 1455.63 46.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "1436.34 74.21 1458.55 82.73 1443.57 63.81 1436.34 74.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1131,1074.61s-9.91-26.1-21.49-23.71-24.25,11.29-24.25,11.29l-18.61,25.16s52.23,20.58,70.6,8.79c0,0,53.34,9.21,120.71-1.84a264,264,0,0,1-19-57.2C1204.85,1056.41,1168.1,1070.84,1131,1074.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1413.57,885.3s-76.38,96.2-174.6,151.8a264,264,0,0,0,19,57.2c51-8.36,109.92-28.31,159.91-72.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M393.46,929.67,545.09,1311a45.17,45.17,0,0,0,48.4,28l397.61-29.36L847.88,904.16a25.31,25.31,0,0,0-24.26-16.33c-69.71,1.61-323.61,7.88-414.44,16A18.82,18.82,0,0,0,393.46,929.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M580.09,1321.7,428.61,937a12,12,0,0,1,10.89-16.39l374.43-14.21a22.68,22.68,0,0,1,22,14.4l137.14,375Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1907.7,929.67,1756.08,1311a45.19,45.19,0,0,1-48.41,28l-397.6-27.83,143.21-407a25.34,25.34,0,0,1,24.27-16.33c69.71,1.61,323.6,7.88,414.43,16A18.82,18.82,0,0,1,1907.7,929.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1721.07,1321.7,1872.56,937a12,12,0,0,0-10.9-16.39l-374.42-14.21a22.7,22.7,0,0,0-22,14.4l-137.13,375Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M841.13,898l4.74,127.36a350.67,350.67,0,0,0,38.5,10.93c7.64-24.59,24.46-54.77,38.23-77.21C872,941.22,841.13,898,841.13,898Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1093.73,895.86c-69.4,74.93-125.58,79.34-171.13,63.24-13.77,22.44-30.59,52.62-38.23,77.21,185.35,40.86,229-129.53,229-129.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1107.81,887.9s8-8.59,22.79-5.89,28,7.84,37.19,0,12.46,2.68,12.46,2.68l-27.61,21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1091.3,902.58s5.48-22.91,22-19.77,54,23.52,63.65,19.77,22-12.75,28.35-9.57l-11.17,13.88s28.7-16.56,33.64-6.39L1180,927.37S1110.15,920.38,1091.3,902.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M600.86,1317.75s-23.68-338.1,149-443.23c0,0,48.27-31.86,108.41,29.85s40.77,125.82-9.7,185.9-101.88,167.4-89.64,227.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M836.83,782.43c-.05,4-57.53,85.69-57.53,85.69s10.31,20.32,59.58,36.82l42.52-87.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M814.22,1062.78s109.07,91.35,226.85,51.49a28.06,28.06,0,0,1,22.11,1.67l33.86,17.88a30.22,30.22,0,0,0,40.06-11.22c4.7-7.86,8.72-16.85,9.52-25.46l-66.26-26.82,4.89-8.13s-32.35-2.74-40.82,20.44c0,0-61.61,25.63-165.52-88.66C878.91,994,831.76,1034.06,814.22,1062.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M808.35,1062.38A2.42,2.42,0,0,1,807,1062c-46.06-31.12-67.72-81.35-67.94-81.85a2.41,2.41,0,1,1,4.44-1.89c.21.49,21.36,49.44,66.2,79.74a2.41,2.41,0,0,1-1.35,4.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M876.76,993a2.39,2.39,0,0,1-2-1.11c-.14-.21-14.18-22.07-40.91-69.94-8.15-14.57-18.83-23.8-31.76-27.42-21.45-6-42.14,5.51-42.35,5.62a2.41,2.41,0,0,1-2.38-4.19c.91-.52,22.58-12.62,46-6.09,14.24,4,25.92,14,34.72,29.73,26.64,47.71,40.61,69.46,40.75,69.68a2.42,2.42,0,0,1-2,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M882.09,735.64s20.46,47,21.83,71.66,6.69,40.66-21.83,45.63-52.54-9.24-65.55-33.81c0,0-20.4-37.85-15.82-53.36S882.09,735.64,882.09,735.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M826.28,801.46l1.62-.72a3.92,3.92,0,0,0,1.92-5.37c-4-7.77-11.86-25.58-1.74-29.73,13-5.35,64.75-15.9,75.91-34.24,10.72-17.63,1.22-40.39-13.06-46.86a2,2,0,0,0-2.57.83l-1.19,2.25a1.93,1.93,0,0,1-3.57-.36h0a1.93,1.93,0,0,0-3.49-.5c-3.43,5.49-12.69,14.38-37.44,19-35.18,6.5-58.44,20.73-59,45a1.94,1.94,0,0,1-3,1.6c-2.6-1.58-6.75-2.32-12.31,2.35-9.66,8.12-5.71,29.2,15.47,46.53a1.92,1.92,0,0,1-.09,3.1c-3.84,2.5-9.56,8.45,5.27,16.38,15.34,8.2,26.8,7.53,31.21,6.8a1.92,1.92,0,0,0,1.56-2.33l-4.71-21.37a1.94,1.94,0,0,1,1.9-2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M827.17,806s-7.81-30-21.26-21.6,7,33.63,17.8,34.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1063.18,1115.94s27.72,27.11,33.07,23.16c1.9-1.4,6.7-6.5,11.36-12.18a11.91,11.91,0,0,0,.81-14l-6.54-10.09a18.9,18.9,0,0,0-28.21-4.11A34.34,34.34,0,0,0,1063.18,1115.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1499.94,1312.77s-.18-121.81-71-247.59a201.55,201.55,0,0,1-23.13-129.76l7.76-50.12s97.2-32.89,204.93-1.38c0,0,149.39,123.3,49.55,438.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1430.12,821.34l25.2,60.55a12,12,0,0,0,9.11,7.25c14.53,2.49,49.68,6.39,72.76-8.79a5.87,5.87,0,0,0,1.57-8.25l-46.56-66.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1492.28,1105.89a5.6,5.6,0,0,0-3.54,8l72.91,139.81a5.6,5.6,0,0,0,6.52,2.79l238.5-68.86a5.59,5.59,0,0,0,3.82-6.93l-41.08-142.23a5.6,5.6,0,0,0-6.8-3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1507.66,1089.46a5.86,5.86,0,0,0-4.14,7.72l58.37,158.55a5.86,5.86,0,0,0,7.12,3.6l237.78-68.65a5.87,5.87,0,0,0,4.1-6.87l-33-152.59a5.86,5.86,0,0,0-7.09-4.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1528.37,1073.46a7.24,7.24,0,0,0-6,8.79l39.65,171.15a7.24,7.24,0,0,0,9.06,5.33l234.18-67.62a7.23,7.23,0,0,0,5-8.76l-36-139.71a7.24,7.24,0,0,0-8.1-5.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1717.94,1138.73c18.17-137.3-87.63-242.87-87.63-242.87l-63,73.39c47.8,59.57,70.52,114.16,80.9,157C1662,1122.28,1695.15,1115.94,1717.94,1138.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1648.24,1127.89a1.61,1.61,0,0,1-1.56-1.23c-12.87-53.18-40-105.8-80.58-156.41a1.6,1.6,0,0,1,.25-2.26,1.62,1.62,0,0,1,2.26.25c40.89,51,68.21,104,81.2,157.67a1.61,1.61,0,0,1-1.19,1.94A1.58,1.58,0,0,1,1648.24,1127.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1648.25,1126.29c9.64,39.85,8.63,69.58,7.16,83.77a11.06,11.06,0,0,1-10.22,9.91c-6.1.43-14.4,1-21.81,1.41-8.15.47-17.2-4.68-23.25-9a3.64,3.64,0,0,0-5.36,4.6c4.52,8.83,16,16.69,23.88,21.32a3.77,3.77,0,0,1-.87,6.88l-33.78,9.58c55.5,52.28,92.14-6.22,92.14-6.22,24.5-37.85,37.17-74.87,41.8-109.83C1695.15,1115.94,1662,1122.28,1648.25,1126.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1456.18,728.71c-1.06,1-44.67,86.64-44.67,86.64l49.43,23.86,53.4-75S1473.9,712,1456.18,728.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1491.87,773.18l-24.65,41.1a8.1,8.1,0,0,1-1.35,1.68c-2.94,2.73-13,10.68-20.74-.14-6.62-9.22-12.83-17.6-19.48-21.06a7.88,7.88,0,0,0-10.64,3.5c-4.06,8-11.93,24.46-16.87,40a7.85,7.85,0,0,0,4.57,9.62c10,4.06,29.79,11.39,47.35,13.81a7.88,7.88,0,0,0,7.45-3.17c7.55-10.34,28.84-39.26,36.1-46.5,6.75-6.72,19.21-4.18,24.82-2.57a7.92,7.92,0,0,0,6.3-.83c5.7-3.43,15.64-12,6.54-26.43a7.89,7.89,0,0,1,2.45-10.72c6.35-4.19,13.25-12,6.68-24.75-6.65-12.87-18.54-14-26.63-13a8.18,8.18,0,0,1-8.59-4.77,5.21,5.21,0,0,0-4.07-3.21,7.65,7.65,0,0,1-6.19-9c1.42-7.28.35-16.74-11.28-23.13-21.33-11.73-40,7.38-44.76,23.51S1458,744.64,1473,746.55c11,1.39,17.06,13.42,19.49,19.71A7.86,7.86,0,0,1,1491.87,773.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M1484.35,827.15s9.49-27.75,21.63-26.73,21.69,13.11,6.65,26.7C1493.91,844,1484.35,827.15,1484.35,827.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1126.29,1326.6a12.87,12.87,0,0,1-12.87,12.87H590.5a19.56,19.56,0,0,1-19.56-19.56l-8.22-9.56,543-4.65a20.9,20.9,0,0,1,20.61,20.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1174.87,1326.6a12.87,12.87,0,0,0,12.87,12.87h522.92a19.56,19.56,0,0,0,19.56-19.56l8.23-9.56-543-4.65a20.91,20.91,0,0,0-20.62,20.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M483.18,1063.1a2.26,2.26,0,0,1-1.89-1c-1.64-2.45-3.38-4.92-5.16-7.32a2.27,2.27,0,0,1,3.64-2.7c1.83,2.46,3.61,5,5.29,7.5a2.26,2.26,0,0,1-1.88,3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M324.44,1360.47c-3.42,0-6.88-.09-10.27-.27a2.27,2.27,0,0,1-2.14-2.39,2.29,2.29,0,0,1,2.38-2.15c5.86.32,11.88.35,17.69.12a2.27,2.27,0,0,1,.19,4.53C329.7,1360.42,327.07,1360.47,324.44,1360.47Zm36.62-3.56a2.27,2.27,0,0,1-.43-4.5c5.59-1.1,11.21-2.46,16.71-4.07l.48-.14a2.27,2.27,0,0,1,1.27,4.36l-.46.13c-5.65,1.65-11.41,3-17.13,4.17A2.2,2.2,0,0,1,361.06,1356.91Zm44.58-14.54a2.27,2.27,0,0,1-1-4.32c5.32-2.49,10.59-5.26,15.65-8.24a2.27,2.27,0,0,1,2.3,3.91c-5.19,3-10.58,5.89-16,8.44A2.34,2.34,0,0,1,405.64,1342.37Zm39.68-24.94a2.27,2.27,0,0,1-1.44-4c4.55-3.71,9-7.68,13.15-11.82a2.27,2.27,0,0,1,3.19,3.23c-4.28,4.23-8.81,8.31-13.46,12.11A2.3,2.3,0,0,1,445.32,1317.43Zm32.37-33.9a2.28,2.28,0,0,1-1.82-3.63c3.5-4.71,6.83-9.64,9.88-14.66a2.27,2.27,0,0,1,3.88,2.35c-3.13,5.15-6.53,10.2-10.12,15A2.27,2.27,0,0,1,477.69,1283.53Zm23.17-40.76a2.21,2.21,0,0,1-.87-.17,2.27,2.27,0,0,1-1.22-3c2.26-5.43,4.29-11,6-16.63a2.27,2.27,0,0,1,4.33,1.35c-1.78,5.74-3.86,11.47-6.17,17A2.27,2.27,0,0,1,500.86,1242.77Zm12.59-45.17a2,2,0,0,1-.34,0,2.28,2.28,0,0,1-1.91-2.58c.87-5.82,1.48-11.74,1.79-17.6a2.27,2.27,0,0,1,4.53.25c-.32,6-.94,12.06-1.83,18A2.26,2.26,0,0,1,513.45,1197.6Zm1.14-46.88a2.27,2.27,0,0,1-2.25-2c-.58-5.84-1.45-11.73-2.58-17.5a2.27,2.27,0,0,1,4.45-.87c1.16,5.91,2,11.94,2.64,17.92a2.27,2.27,0,0,1-2,2.49ZM504.27,1105a2.26,2.26,0,0,1-2.13-1.51c-2-5.55-4.25-11-6.73-16.36a2.27,2.27,0,0,1,4.11-1.92c2.54,5.44,4.86,11.07,6.89,16.75a2.27,2.27,0,0,1-1.37,2.9A2.32,2.32,0,0,1,504.27,1105Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M285.36,1356.4a2.59,2.59,0,0,1-.47-.05c-3-.62-6-1.33-8.93-2.1a2.27,2.27,0,0,1,1.14-4.39c2.89.75,5.83,1.44,8.73,2.05a2.27,2.27,0,0,1-.47,4.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M162.05,1269.88a2.28,2.28,0,0,1-1.93-1.08c-1.61-2.61-3.17-5.28-4.64-7.93a2.27,2.27,0,0,1,4-2.19c1.43,2.58,2.95,5.19,4.52,7.74a2.27,2.27,0,0,1-1.93,3.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M145.55,1236a2.27,2.27,0,0,1-2.13-1.48c-1.61-4.33-3.08-8.8-4.39-13.28-.36-1.23-.71-2.46-1-3.69a2.27,2.27,0,1,1,4.38-1.18c.33,1.2.67,2.4,1,3.6,1.28,4.37,2.73,8.74,4.3,13a2.27,2.27,0,0,1-1.34,2.91A2.2,2.2,0,0,1,145.55,1236Zm-10.77-44.86a2.26,2.26,0,0,1-2.25-2c-.68-5.88-1.09-11.86-1.23-17.78a2.27,2.27,0,1,1,4.54-.1c.13,5.78.53,11.62,1.2,17.36a2.27,2.27,0,0,1-2,2.51Zm.32-46.14-.3,0a2.26,2.26,0,0,1-2-2.54c.76-5.87,1.8-11.78,3.1-17.55a2.27,2.27,0,0,1,4.43,1c-1.27,5.65-2.29,11.41-3,17.14A2.28,2.28,0,0,1,135.1,1145Zm11.42-44.7a2.39,2.39,0,0,1-.83-.15,2.29,2.29,0,0,1-1.29-2.94c2.15-5.52,4.58-11,7.22-16.29a2.27,2.27,0,1,1,4.06,2c-2.58,5.17-5,10.53-7.05,15.91A2.27,2.27,0,0,1,146.52,1100.34Zm21.77-40.67a2.23,2.23,0,0,1-1.3-.41,2.27,2.27,0,0,1-.56-3.16c3.4-4.85,7.07-9.59,10.9-14.1a2.27,2.27,0,1,1,3.45,2.94c-3.73,4.4-7.31,9-10.63,13.76A2.27,2.27,0,0,1,168.29,1059.67Zm30.85-34.28a2.27,2.27,0,0,1-1.49-4c4.46-3.89,9.16-7.61,14-11.07a2.27,2.27,0,1,1,2.65,3.68c-4.69,3.38-9.27,7-13.63,10.81A2.28,2.28,0,0,1,199.14,1025.39Zm38.2-25.85a2.27,2.27,0,0,1-1-4.29c5.26-2.69,10.72-5.17,16.22-7.37a2.27,2.27,0,0,1,1.69,4.21c-5.38,2.15-10.71,4.58-15.84,7.2A2.24,2.24,0,0,1,237.34,999.54Zm43.29-15.92a2.26,2.26,0,0,1-.52-4.47c5.78-1.37,11.67-2.49,17.51-3.32a2.27,2.27,0,0,1,.64,4.5c-5.71.81-11.46,1.89-17.11,3.23A2.31,2.31,0,0,1,280.63,983.62Zm63.43-4.16h-.23c-5.75-.59-11.59-.92-17.37-1a2.27,2.27,0,0,1,0-4.54h0c5.92.06,11.91.4,17.8,1a2.27,2.27,0,0,1-.24,4.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M381,987.05a2.35,2.35,0,0,1-.68-.11c-2.83-.88-5.73-1.71-8.61-2.45a2.27,2.27,0,0,1,1.14-4.4c2.95.77,5.92,1.62,8.82,2.52a2.27,2.27,0,0,1-.67,4.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M385.25,1033.66a2.29,2.29,0,0,0-2.65.23L361.36,1052a121.07,121.07,0,0,0-39-5.54L307,1023.17a2.29,2.29,0,0,0-2.48-1l-32.41,8.33a2.3,2.3,0,0,0-1.71,2l-2.24,27.79A121.41,121.41,0,0,0,236.72,1084l-27.33-5.59a2.29,2.29,0,0,0-2.43,1.08l-17,28.81a2.29,2.29,0,0,0,.22,2.65l18.08,21.25a121.61,121.61,0,0,0-5.54,39l-23.26,15.37a2.29,2.29,0,0,0-1,2.48l8.34,32.4a2.29,2.29,0,0,0,2,1.72l27.78,2.23a121.68,121.68,0,0,0,23.66,31.47l-5.58,27.33a2.29,2.29,0,0,0,1.08,2.43l28.81,17a2.29,2.29,0,0,0,2.65-.23l21.24-18.08a121.36,121.36,0,0,0,39,5.55l15.36,23.26a2.3,2.3,0,0,0,2.48.95l32.41-8.33a2.29,2.29,0,0,0,1.71-2l2.24-27.79a121.41,121.41,0,0,0,31.46-23.66l27.33,5.59a2.29,2.29,0,0,0,2.43-1.08l17-28.81a2.29,2.29,0,0,0-.22-2.65l-18.08-21.24a121.71,121.71,0,0,0,5.54-39l23.26-15.37a2.3,2.3,0,0,0,1-2.48l-8.34-32.4a2.29,2.29,0,0,0-2-1.72l-27.79-2.23a121.68,121.68,0,0,0-23.66-31.47l5.58-27.33a2.29,2.29,0,0,0-1.08-2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M325,1201.78a33.16,33.16,0,1,1,15.8-4A32.89,32.89,0,0,1,325,1201.78Zm-.09-59.44a26.11,26.11,0,0,0-12.55,3.22h0a26.3,26.3,0,1,0,20-2.14A26.57,26.57,0,0,0,324.89,1142.34Zm-14.18.23h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M324.63,1253.45a84.16,84.16,0,0,1-3.25-168.25l.27,6.8a78.35,78.35,0,0,0-16.29,2.4h0c-.69.18-1.37.36-2.05.56a77.44,77.44,0,0,0-54.73,88.46c.33,1.71.7,3.43,1.15,5.14A77.33,77.33,0,1,0,379,1114.31l4.78-4.85a84.18,84.18,0,0,1-59.16,144Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M615.26,992.54a2.27,2.27,0,0,1-2-1.1c-1.52-2.51-3.18-5-4.94-7.35a2.27,2.27,0,0,1,3.65-2.7c1.83,2.47,3.58,5.07,5.17,7.7a2.27,2.27,0,0,1-1.93,3.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M545.53,1140.53a2.27,2.27,0,0,1-.33-4.51,96.93,96.93,0,0,0,13-2.84c1.51-.44,3-.91,4.46-1.42a2.27,2.27,0,1,1,1.48,4.29c-1.53.53-3.09,1-4.67,1.48a103,103,0,0,1-13.61,3Zm44.26-18.24a2.27,2.27,0,0,1-1.35-4.09,96.24,96.24,0,0,0,13.36-12,2.27,2.27,0,0,1,3.34,3.07,100.58,100.58,0,0,1-14,12.58A2.25,2.25,0,0,1,589.79,1122.29Zm30.33-37a2.27,2.27,0,0,1-2-3.24,96.39,96.39,0,0,0,6.11-16.9,2.27,2.27,0,0,1,4.4,1.14,100.82,100.82,0,0,1-6.41,17.69A2.25,2.25,0,0,1,620.12,1085.27Zm9.24-47a2.26,2.26,0,0,1-2.26-2.15,95.69,95.69,0,0,0-2.65-17.77,2.27,2.27,0,0,1,4.41-1.09,101.36,101.36,0,0,1,2.77,18.62,2.28,2.28,0,0,1-2.15,2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M515.61,1140.29a2.22,2.22,0,0,1-.37,0c-3-.5-6.09-1.14-9.08-1.92a2.27,2.27,0,1,1,1.14-4.39c2.85.74,5.77,1.36,8.67,1.83a2.27,2.27,0,0,1-.36,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M447.93,1095A2.27,2.27,0,0,1,446,1094c-1.61-2.62-3.13-5.36-4.5-8.12a2.27,2.27,0,0,1,4.06-2c1.31,2.64,2.76,5.25,4.3,7.75a2.27,2.27,0,0,1-.74,3.13A2.32,2.32,0,0,1,447.93,1095Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M434.55,1059.16a2.27,2.27,0,0,1-2.24-1.9,100.15,100.15,0,0,1-1.31-16.12c0-.79,0-1.57,0-2.36a2.27,2.27,0,0,1,4.54.11q0,1.13,0,2.25a95.75,95.75,0,0,0,1.25,15.39,2.27,2.27,0,0,1-1.87,2.6Zm3.84-46.93a2.33,2.33,0,0,1-.73-.12,2.27,2.27,0,0,1-1.42-2.87,100.13,100.13,0,0,1,7.49-16.92,2.27,2.27,0,1,1,4,2.21,96.28,96.28,0,0,0-7.15,16.16A2.27,2.27,0,0,1,438.39,1012.23Zm25.25-39.74a2.27,2.27,0,0,1-1.57-3.91,100.28,100.28,0,0,1,14.5-11.49,2.27,2.27,0,0,1,2.48,3.8,95,95,0,0,0-13.84,11A2.28,2.28,0,0,1,463.64,972.49Zm40.86-23.37a2.27,2.27,0,0,1-.62-4.45,101.26,101.26,0,0,1,18.19-3.43,2.27,2.27,0,0,1,.42,4.52A96.85,96.85,0,0,0,505.12,949,2.16,2.16,0,0,1,504.5,949.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M560.41,949.75a2.22,2.22,0,0,1-.67-.1c-2.81-.88-5.7-1.63-8.57-2.24a2.27,2.27,0,0,1,.94-4.44c3,.64,6,1.43,9,2.34a2.27,2.27,0,0,1-.68,4.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M562.58,972.59a1.16,1.16,0,0,0-1.36.12L550.3,982a62.35,62.35,0,0,0-20-2.84l-7.89-11.95a1.17,1.17,0,0,0-1.28-.49L504.47,971a1.16,1.16,0,0,0-.88,1l-1.15,14.28a62.51,62.51,0,0,0-16.16,12.15l-14-2.87a1.19,1.19,0,0,0-1.25.56l-8.74,14.8a1.18,1.18,0,0,0,.11,1.36l9.29,10.91a62.43,62.43,0,0,0-2.85,20l-11.94,7.89a1.2,1.2,0,0,0-.5,1.28l4.29,16.65a1.17,1.17,0,0,0,1,.88l14.28,1.14a62.39,62.39,0,0,0,12.15,16.17l-2.87,14a1.16,1.16,0,0,0,.56,1.24l14.79,8.75a1.19,1.19,0,0,0,1.37-.12l10.91-9.29a62.36,62.36,0,0,0,20,2.85l7.89,12a1.17,1.17,0,0,0,1.28.49l16.64-4.28a1.18,1.18,0,0,0,.88-1.05l1.15-14.27a62.15,62.15,0,0,0,16.16-12.16l14,2.87a1.18,1.18,0,0,0,1.25-.55l8.74-14.8a1.18,1.18,0,0,0-.11-1.36l-9.29-10.91a62.43,62.43,0,0,0,2.85-20l12-7.9a1.19,1.19,0,0,0,.49-1.27l-4.28-16.65a1.2,1.2,0,0,0-1-.88l-14.27-1.15a62.77,62.77,0,0,0-12.16-16.16l2.87-14a1.18,1.18,0,0,0-.55-1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M531.62,1060.61a18.83,18.83,0,0,1-5.3-.77,18.51,18.51,0,1,1,5.3.77Zm0-30.53a11.75,11.75,0,0,0-5.65,1.44,11.87,11.87,0,1,0,5.65-1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M531.35,1087.16a44.89,44.89,0,0,1-11.1-88.36l.29-.07a44.6,44.6,0,0,1,8.57-1.29l.59,0,.27,6.8a39,39,0,0,0-8,1.18h0a38,38,0,1,0,36.26,9.8l4.78-4.84a44.93,44.93,0,0,1-31.64,76.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M813,604.57c6.07-2.08,5.2-11-1.16-11.77-29-3.76-71.48-15.11-85.39-49.12-21.83-53.37,23.39-259.12-184.35-295.93-191.63-34-298.35,26.68-295.93,203.75C248.49,623.14,524.33,703.62,813,604.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 340.36,
    y: 414.48,
    width: 18.59,
    height: 145.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 371.42,
    y: 464.47,
    width: 18.59,
    height: 95.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 402.47,
    y: 340.93,
    width: 18.59,
    height: 219
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 433.53,
    y: 507.32,
    width: 18.59,
    height: 52.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 464.59,
    y: 370.21,
    width: 18.59,
    height: 189.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 495.65,
    y: 403.06,
    width: 18.59,
    height: 156.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 526.71,
    y: 438.76,
    width: 18.59,
    height: 121.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 557.76,
    y: 296.65,
    width: 18.59,
    height: 263.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 588.82,
    y: 324.5,
    width: 18.59,
    height: 235.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 619.88,
    y: 366.64,
    width: 18.59,
    height: 193.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 650.94,
    y: 512.2,
    width: 18.59,
    height: 47.73
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductionSupport3);
export default __webpack_public_path__ + "static/media/production_support_3.f44d6f8b0a4c81882fc60702b1e33ade.svg";
export { ForwardRef as ReactComponent };